import { ReactNode } from "react";
import { ToastMessage } from "@almafintech/react-components/ToastMessage";
import Stepper from "../Stepper/Stepper";
import SupportButton from "../SupportButton/SupportButton";
import useWindowWidth from "../../hooks/useWindowWidth";

import styles from "./Layout.module.scss";
import {
  getCompanyData,
  isToros,
  isWina,
  isLandToken,
  isLaBragadense,
  isAllariaOnboarding,
  isAllariaMasOnboarding,
  isPhysicalOnboarding,
  isMabra,
} from "../../utils";

import torosCapitalLogo from "../../assets/images/logos/toros-capital.png";
import winaLogo from "../../assets/images/logos/wina.svg";
import landTokenLogo from "../../assets/images/logos/landtoken.svg";
import laBragadenseLogo from "../../assets/images/logos/labragadense.svg";
import mabraLogo from "../../assets/images/logos/Mabra.svg";
import { useAppSelector } from "../../app/hooks";
import LanguagePicker from "../LanguagePicker/LanguagePicker";

interface Props {
  children: ReactNode;
  hideStepper?: boolean;
  hideLogo?: boolean;
  hideSupportButton?: boolean;
  showLanguagePicker?: boolean;
  className?: string;
}

const Layout = ({
  children,
  className,
  hideStepper,
  hideLogo,
  hideSupportButton,
  showLanguagePicker,
}: Props) => {
  const {
    container,
    header,
    body,
    button,
    companyLogo,
    torosLogo,
    winaLogoStyles,
    landToken,
    laBragadense,
    mabra,
  } = styles;

  const dimensions = useWindowWidth();
  const isMobile = dimensions.width < 768;

  const { formValues } = useAppSelector(({ onboardingData }) => onboardingData);

  const { onboardingType } = useAppSelector(
    ({ activeTemplate }) => activeTemplate
  );

  const { logo, logoClassname, companyName } = getCompanyData();

  return (
    <div className={container}>
      <div className={header}>
        {isLaBragadense(formValues) &&
          !hideLogo &&
          isAllariaMasOnboarding() && (
            <img
              className={laBragadense}
              src={laBragadenseLogo}
              alt="La Bragadense logo"
            />
          )}
        {isMabra(formValues) && !hideLogo && (
          <img className={mabra} src={mabraLogo} alt="Mabra logo" />
        )}
        {isLandToken(formValues) &&
          !hideLogo &&
          isAllariaOnboarding() &&
          isPhysicalOnboarding(onboardingType) && (
            <img
              className={landToken}
              src={landTokenLogo}
              alt="Land Token logo"
            />
          )}
        {isToros(formValues) && !hideLogo && isAllariaOnboarding() && (
          <img
            className={torosLogo}
            src={torosCapitalLogo}
            alt="Toros Capital logo"
          />
        )}
        {isWina(formValues) && !hideLogo && isAllariaOnboarding() && (
          <img className={winaLogoStyles} src={winaLogo} alt="Wina logo" />
        )}
        {!hideStepper && !isMobile && <Stepper />}
        {!hideLogo && (
          <img
            className={`${companyLogo} ${
              logoClassname ? styles[logoClassname] : ""
            }`}
            src={logo}
            alt={`${companyName} logo`}
          />
        )}
      </div>
      <ToastMessage messageId="layoutPage" position="top-right" />
      <div className={`${body} ${className}`}>{children}</div>
      {!hideSupportButton && <SupportButton className={button} />}

      {/* LanguagePicker is usually shown on a `FormContainer`'s header, but it
      looks weird on mobile, so we tuck it on top-left corner of layout instead */}
      {showLanguagePicker && isMobile && (
        <LanguagePicker className="absolute" />
      )}
    </div>
  );
};

export default Layout;
